import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../../base/BaseComponent'; 
import { getAjaxhelper } from 'src/utils';
 
export interface HotelDescriptionProps extends BaseComponentProps {
    hotelCode: number;
    lang: string;
}
export interface HotelDescriptionState extends BaseComponentState { 
    hotel: any;
    requesting: boolean;
}

export class HotelDescription extends BaseComponent<HotelDescriptionProps, HotelDescriptionState> {

    constructor(props: HotelDescriptionProps) {
        super(props);
        this.state = {
            hotel: {}, requesting: true
        };
    }
 
    getData = () => {
        getAjaxhelper().post(`/dynamics/hb-api/hotel-detail`, {
            lang: this.props.lang,
            hotelCode: this.props.hotelCode
        }).then(
            (hotel: any) => { 
                this.setState({ requesting: false, hotel });
            }).catch((exc) => { console.error('error: ', exc); });
    }

    componentDidMount() {
        this.getData();
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let hotelDes = '';
        let hotelFacilities: any[] = []; 
        if (this.state.requesting === false) {
            if ((this.state.hotel.description)) {
                hotelDes = this.state.hotel.description;
            }
            let lop = 0;
            if (this.state.hotel && this.state.hotel.facilitiesGroup) {
                for (let a of this.state.hotel.facilitiesGroup!) {
                    if (a.code !== 20 && a.code !== 30) { // && a.code !== 20 && a.code !== 30 && a.code !== 40
                        let fasDetail = [];
                        let lop1 = 0;
                        for (let b of a.Facilities!) {
                            lop1++;
                            let style = {};
                            let ico = <i className="ti-check" />;
                            if (b.indLogic === "FALSE") {
                                ico = <i className="ti-close" />; 
                            } else {
                                style = {};
                            } 
                            
                            if (b.indYesOrNo === "FALSE") { 
                                style = { fontStyle: "italic" };
                            } else {
                                style = { fontWeight: 500 };
                            }

                            let bintang = <span style={{ color: 'FF0000' }}>*</span>;
                            if (b.indFee === "FALSE") {
                                bintang = <span/>;
                            }
                            let buri = <span />;
                            if ((b.number) && b.number !== 0) {
                                buri = <span> - {b.number}</span>;
                            }
                            fasDetail.push(
                                <div key={lop1} style={style} className="col-md-3">{ico} {b.description!} {buri} {bintang}</div>
                            );
                        }
                        lop++;
                        hotelFacilities.push(
                            <div key={lop} className='' style={{ marginTop: 30 }}>
                                <h4 className="facilitiesHeader" style={{ width: '100%', borderBottom: '1px solid' }} > {a.description}</h4>
                                <div className="row" style={{ width: '100%' }}> {fasDetail}</div>
                            </div>
                        );
                    }
                }
            }
        }
        return (
            <div style={{padding: '30px 15px'}}>
                <h3>Hotel Description</h3>
                <p>{hotelDes}</p>
                <h3>Facilities</h3>
                {hotelFacilities}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/details/HotelDescription.tsx